import OrderDTO from "@/dto/order/OrderDTO";
import OrderItemDTO from "@/dto/order/OrderItemDTO";
import { useModalStore } from "@/hooks/Modal/hooks";
import EditSimpleTitleDialog from "@/scenes/OrderManagement/components/dialogs/EditSimpleTitleDialog";
import { Tag, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";

interface OrderItemTitleProps {
    order: OrderDTO;

    mergerOrder: OrderDTO;

    orderItem: OrderItemDTO;
}

const OrderItemTitle: React.FC<OrderItemTitleProps> = observer(({ order, mergerOrder, orderItem }) => {
    const modalStore = useModalStore();

    function onEditSimpleTitleClick(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
        event.preventDefault();

        modalStore.openModal(EditSimpleTitleDialog, {
            order,
            orderItem,
            mergerOrder,
        });
    }

    return (
        <>
            <p className="mb5">
                标题：
                {orderItem.isPurchasingLabelPrinted ? (
                    <Tooltip title="已打印拿货标签">
                        <span
                            style={{
                                width: "16px",
                                background: "#cc0000",
                                height: "16px",
                                borderRadius: "2px",
                                display: "inline-block",
                                padding: "0 1px",
                                fontSize: "12px",
                                lineHeight: "16px",
                                color: "#ffffff",
                                margin: "0 3px 3px 0",
                                textAlign: "center",
                                cursor: "pointer",
                            }}
                        >
                            拿
                        </span>
                    </Tooltip>
                ) : null}
                <span className="text-secondary break-spaces">{orderItem.title}</span>
                {!orderItem.simpleTitle ? (
                    <Tooltip title="设置商品简称">
                        <a href="#" className="small text-light  ml5 mr10" onClick={onEditSimpleTitleClick}>
                            [设置简称]
                        </a>
                    </Tooltip>
                ) : null}
            </p>

            {orderItem.simpleTitle ? (
                <p>
                    简称：<span className="text-secondary">{orderItem.simpleTitle}</span>
                    <Tooltip title="修改简称">
                        <a href="#" className="small text-light ml5 mr10" onClick={onEditSimpleTitleClick}>
                            [修改]
                        </a>
                    </Tooltip>
                </p>
            ) : null}
        </>
    );
});

export default OrderItemTitle;
